"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.dialogRegistry = exports.DialogRegistry = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/concat"));

var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/set"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var DialogRegistry = /*#__PURE__*/function () {
  function DialogRegistry() {
    var _this = this;

    (0, _classCallCheck2.default)(this, DialogRegistry);
    this._dialogs = [];
    this._showActions = new _set.default();

    this.addDialog = function (dialog) {
      var _context;

      _this._dialogs = (0, _concat.default)(_context = _this._dialogs).call(_context, dialog);

      _this._showActions.add(dialog.dialogAction);
    };
  }

  (0, _createClass2.default)(DialogRegistry, [{
    key: "addAction",
    value: function addAction(type) {
      this._showActions.add(type);
    }
    /**
     * Internal portal-app package use only to get the dialog registrations
     *
     * @internal
     */

  }, {
    key: "getDialogs",
    value: function getDialogs() {
      return this._dialogs;
    }
    /**
     * Internal portal-app use only to determine if the current action is a show dialog action
     *
     * @internal
     */

  }, {
    key: "hasShowAction",
    value: function hasShowAction(typeName) {
      return this._showActions.has(typeName);
    }
  }]);
  return DialogRegistry;
}();

exports.DialogRegistry = DialogRegistry;
var dialogRegistry = new DialogRegistry();
exports.dialogRegistry = dialogRegistry;